import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { QueryBuilderUtils } from "../QueryBuilderUtils";
import { ObjectUtils } from "../../util/ObjectUtils";
import { TypeORMError } from "../../error/TypeORMError";
export var RelationCountAttribute = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function RelationCountAttribute(expressionMap, relationCountAttribute) {
    _classCallCheck(this, RelationCountAttribute);
    this.expressionMap = expressionMap;
    ObjectUtils.assign(this, relationCountAttribute || {});
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  _createClass(RelationCountAttribute, [{
    key: "joinInverseSideMetadata",
    get: function get() {
      return this.relation.inverseEntityMetadata;
    }
    /**
     * Alias of the parent of this join.
     * For example, if we join ("post.category", "categoryAlias") then "post" is a parent alias.
     * This value is extracted from entityOrProperty value.
     * This is available when join was made using "post.category" syntax.
     */
  }, {
    key: "parentAlias",
    get: function get() {
      if (!QueryBuilderUtils.isAliasProperty(this.relationName)) throw new TypeORMError("Given value must be a string representation of alias property");
      return this.relationName.split(".")[0];
    }
    /**
     * Relation property name of the parent.
     * This is used to understand what is joined.
     * For example, if we join ("post.category", "categoryAlias") then "category" is a relation property.
     * This value is extracted from entityOrProperty value.
     * This is available when join was made using "post.category" syntax.
     */
  }, {
    key: "relationProperty",
    get: function get() {
      if (!QueryBuilderUtils.isAliasProperty(this.relationName)) throw new TypeORMError("Given value is a string representation of alias property");
      return this.relationName.split(".")[1];
    }
  }, {
    key: "junctionAlias",
    get: function get() {
      var _this$relationName$sp = this.relationName.split("."),
        _this$relationName$sp2 = _slicedToArray(_this$relationName$sp, 2),
        parentAlias = _this$relationName$sp2[0],
        relationProperty = _this$relationName$sp2[1];
      return parentAlias + "_" + relationProperty + "_rc";
    }
    /**
     * Relation of the parent.
     * This is used to understand what is joined.
     * This is available when join was made using "post.category" syntax.
     */
  }, {
    key: "relation",
    get: function get() {
      if (!QueryBuilderUtils.isAliasProperty(this.relationName)) throw new TypeORMError("Given value is a string representation of alias property");
      var _this$relationName$sp3 = this.relationName.split("."),
        _this$relationName$sp4 = _slicedToArray(_this$relationName$sp3, 2),
        parentAlias = _this$relationName$sp4[0],
        propertyPath = _this$relationName$sp4[1];
      var relationOwnerSelection = this.expressionMap.findAliasByName(parentAlias);
      var relation = relationOwnerSelection.metadata.findRelationWithPropertyPath(propertyPath);
      if (!relation) throw new TypeORMError("Relation with property path ".concat(propertyPath, " in entity was not found."));
      return relation;
    }
    /**
     * Metadata of the joined entity.
     * If table without entity was joined, then it will return undefined.
     */
  }, {
    key: "metadata",
    get: function get() {
      if (!QueryBuilderUtils.isAliasProperty(this.relationName)) throw new TypeORMError("Given value is a string representation of alias property");
      var parentAlias = this.relationName.split(".")[0];
      var selection = this.expressionMap.findAliasByName(parentAlias);
      return selection.metadata;
    }
  }, {
    key: "mapToPropertyPropertyName",
    get: function get() {
      return this.mapToProperty.split(".")[1];
    }
  }]);
  return RelationCountAttribute;
}();